/* Tab, Oct 11 2026 (Abraham 2:32 PM): product cards show a RANDOM set/colour of each style on every page load instead of always Set-1,
   so collection grids, search results and "Complete the set" look colourful. The card carries each set's variant image + id in
   data-tab-variants (snippets/product-card.liquid); this picks one per card, swaps the main photo (same square box, no layout shift),
   and points the card's links at that variant (?variant=) so the product page opens on the set shown. Neighbouring cards avoid the
   same colour word / set number. The hover photos are untouched. Theme copy only. */
(function () {
  'use strict';
  var lastFamily = null;
  function family(v) { var w = v.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().split(' '); return w[w.length - 1]; }
  function parse(card) {
    var raw = card.getAttribute('data-tab-variants'); if (!raw) return null;
    var list = raw.split(';;').map(function (s) { var p = s.split('|'); return p.length >= 3 && p[2] ? { value: p[0], id: p[1], src: p[2] } : null; }).filter(Boolean);
    return list.length > 1 ? list : null;
  }
  function pick(list) {
    var c, tries = 0;
    do { c = list[Math.floor(Math.random() * list.length)]; tries++; } while (lastFamily && family(c.value) === lastFamily && tries < 8);
    lastFamily = family(c.value); return c;
  }
  function apply(card) {
    if (card.dataset.tabRandomized) return;
    var list = parse(card); if (!list) return;
    card.dataset.tabRandomized = '1';
    var img = card.querySelector('img.product-primary-image'); if (!img) return;
    var c = pick(list);
    var u770 = c.src, u375 = c.src.replace(/width=770/, 'width=375');
    img.removeAttribute('data-srcset'); img.removeAttribute('data-src');
    img.classList.remove('lazyload'); img.classList.add('lazyloaded', 'no-blur');
    img.setAttribute('sizes', '(max-width: 767px) 50vw, 25vw');
    img.setAttribute('srcset', u375 + ' 375w, ' + u770 + ' 770w');
    img.setAttribute('src', u770);
    img.setAttribute('loading', 'lazy');
    card.setAttribute('data-tab-shown', c.value);
    card.querySelectorAll('a.product-featured-image-link, a.product-card-title, a.tab-choose-link').forEach(function (a) {
      try { var u = new URL(a.getAttribute('href'), location.origin); u.searchParams.set('variant', c.id); a.setAttribute('href', u.pathname + u.search); } catch (e) {}
    });
  }
  function run(root) { (root || document).querySelectorAll('product-card[data-tab-variants]').forEach(apply); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); }); else run();
  new MutationObserver(function (ms) {
    ms.forEach(function (m) { m.addedNodes.forEach(function (n) {
      if (n.nodeType !== 1) return;
      if (n.tagName === 'PRODUCT-CARD') apply(n); else if (n.querySelector && n.querySelector('product-card[data-tab-variants]')) run(n);
    }); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
